import actionTypes from "../actionTypes";

export const GET_PAYMENT_ANALYTICS = actionTypes("GET_PAYMENT_ANALYTICS");
export const GET_TRANSFER_ANALYTICS = actionTypes("GET_TRANSFER_ANALYTICS");
